module.exports = __webpack_public_path__ + "static/img/douyin.9a500c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/douyin.jpg
// module id = DAL0
// module chunks = 1